<template>
  <CustomerSelect :selected-id="customerId" :error="error" :create-customer-allowed="true" @selected="onSelect" />
</template>

<script lang="ts">
import { computed, defineComponent, type ComputedRef } from 'vue'
import { useAssignmentFormStore } from '@/store/assignmentForm'
import CustomerSelect from '@/views/Components/Customer/CustomerSelect.vue'

export default defineComponent({
  name: 'Customer',
  components: {
    CustomerSelect,
  },
  setup() {
    const assignmentFormStore = useAssignmentFormStore()

    const customerId: ComputedRef<string | null> = computed(() => assignmentFormStore.assignment.company_id)
    const error: ComputedRef<string> = computed(() => assignmentFormStore.errors.company_id)

    const onSelect = (id: string) => assignmentFormStore.setFields({ company_id: id })

    return {
      error,
      customerId,
      onSelect,
    }
  },
})
</script>
